import { Locale } from '../../domain/Translation';

export const getLocaleUrl = (route: string, locale: Locale) =>
  route.replace(':locale', locale);

export const isValidUrl = (url: string): boolean => {
  let testUrl;

  try {
    testUrl = new URL(url);
  } catch (_) {
    return false;
  }

  return testUrl.protocol === 'http:' || testUrl.protocol === 'https:';
};
